import useClientStore from '@/store/useClientStore';

/**
 * URL del widget de chatbot embebido de la automotora, si tiene uno configurado
 * (`integrations.chatbot_widget_url`). Cuando existe, ese chatbot reemplaza a los
 * botones flotantes de WhatsApp del sitio, así que los ocultamos.
 *
 * El config viaja en el client store (ClientProvider selecciona `integrations`);
 * el site principal no monta ClientWebsiteConfigProvider. Además el join de
 * Supabase puede devolver `client_website_config` como array u objeto (mismo
 * manejo que Navbar), así que normalizamos antes de leer.
 */
export function useChatbotWidgetUrl(): string | undefined {
  const client = useClientStore((s) => s.client);
  const raw = client?.client_website_config;
  const cfg = Array.isArray(raw) ? raw[0] : raw;
  return cfg?.integrations?.chatbot_widget_url;
}
